export default __webpack_public_path__ + "static/media/success_disabled.caf8477a.svg";